var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.495 14.79c.447.446 1.22.13 1.22-.505v-8.57c0-.64-.774-.952-1.22-.506L.21 9.495c-.278.279-.278.731 0 1.01l4.286 4.285zm14.79 2.353H.716c-.395 0-.715.32-.715.714v1.429c0 .394.32.714.714.714h18.572c.394 0 .714-.32.714-.714v-1.429c0-.394-.32-.714-.714-.714zm.142-5.714H9.144c-.152 0-.298.06-.405.167-.107.108-.168.253-.168.405v1.712c0 .152.06.298.168.405.107.108.253.168.405.168h10.283c.152 0 .298-.06.405-.168.108-.107.168-.253.168-.405V12c0-.152-.06-.297-.168-.405-.107-.107-.253-.168-.405-.167zm0-5.715H9.144c-.152 0-.298.06-.405.168-.107.107-.168.253-.168.405V8c0 .152.06.297.168.405.107.107.253.168.405.167h10.283c.152 0 .298-.06.405-.167.108-.108.168-.253.168-.405V6.287c0-.152-.06-.298-.168-.405-.107-.108-.253-.168-.405-.168zM19.286 0H.714C.32 0 0 .32 0 .714v1.429c0 .394.32.714.714.714h18.572c.394 0 .714-.32.714-.714V.714C20 .32 19.68 0 19.286 0z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdent);
export default __webpack_public_path__ + "static/media/outdent.2724512d26cbe75c6e1099f2a517f8ff.svg";
export { ForwardRef as ReactComponent };